import React from 'react';
import { ChevronRight } from 'lucide-react';

export default function Hero({ lang }) {
  const t = {
    tag: lang === 'bg'
      ? 'СКОРОСТ / СИЛА / ИЗДРЪЖЛИВОСТ'
      : 'SPEED / POWER / ENDURANCE',
    headline1: lang === 'bg' ? 'ТРЕНИРАЙ' : 'TRAIN',
    headline2: lang === 'bg' ? 'КАТО ШАМПИОН' : 'LIKE A CHAMPION',
    headline3: lang === 'bg' ? 'ПОСТИГНИ ПОВЕЧЕ' : 'ACHIEVE MORE',
    sub: lang === 'bg'
      ? 'SportAppPros е създаден от треньори и бивши спортисти. Реални протоколи за спортно представяне — за теб, не за огледалото.'
      : 'SportAppPros was built by coaches and ex-athletes. Real sports performance protocols — for you, not for the mirror.',
    cta: lang === 'bg' ? 'СТАНИ ПРО' : 'GO PRO',
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage:
            'url(https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=1600&q=80)',
        }}
      />
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-black/60" />
      {/* Extra gradient overlay for polish */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#0f172a]/70 via-transparent to-[#0f172a]" />

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center pt-20">
        {/* Tag line */}
        <div className="inline-flex items-center gap-2 mb-6 md:mb-8">
          <span className="w-8 h-[2px] bg-orange-500" />
          <span className="text-orange-400 font-bold text-xs md:text-sm tracking-[0.3em] uppercase">
            {t.tag}
          </span>
          <span className="w-8 h-[2px] bg-orange-500" />
        </div>

        {/* Big headline */}
        <h1 className="font-black uppercase leading-none mb-6">
          <span className="block text-5xl sm:text-7xl md:text-8xl lg:text-9xl text-white drop-shadow-2xl">
            {t.headline1}
          </span>
          <span
            className="block text-5xl sm:text-7xl md:text-8xl lg:text-9xl"
            style={{
              background: 'linear-gradient(90deg, #f97316, #f59e0b)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
            }}
          >
            {t.headline2}
          </span>
          <span className="block text-5xl sm:text-7xl md:text-8xl lg:text-9xl text-white drop-shadow-2xl">
            {t.headline3}
          </span>
        </h1>

        {/* Subtext */}
        <p className="mt-6 text-base md:text-xl text-slate-200 max-w-2xl mx-auto leading-relaxed font-medium">
          {t.sub}
        </p>

        {/* CTA */}
        <div className="mt-10 flex justify-center">
          <a
            href="/s"
            className="group inline-flex items-center gap-3 px-8 md:px-12 py-4 md:py-5 rounded-full font-black text-base md:text-lg tracking-widest uppercase text-white shadow-2xl shadow-orange-500/40 transition-all duration-300 hover:scale-105 hover:shadow-orange-500/60"
            style={{
              background: 'linear-gradient(135deg, #f97316 0%, #f59e0b 100%)',
            }}
          >
            {t.cta}
            <ChevronRight className="w-5 h-5 transition-transform group-hover:translate-x-1" />
          </a>
        </div>

        {/* Scroll indicator */}
        <div className="mt-16 md:mt-24 flex justify-center">
          <div className="w-6 h-10 rounded-full border-2 border-white/30 flex justify-center pt-2">
            <div className="w-1.5 h-1.5 rounded-full bg-orange-400 animate-bounce" />
          </div>
        </div>
      </div>

      {/* Bottom angled divider */}
      <div
        className="absolute bottom-0 left-0 right-0 h-24 bg-[#0f172a]"
        style={{ clipPath: 'polygon(0 100%, 100% 100%, 100% 0)' }}
      />
    </section>
  );
}
